import { motion, AnimatePresence } from "framer-motion";
import { Lock, LockOpen } from "lucide-react";
import { useUnlock } from "@/context/TokenDataContext";

export const UnlockStatus = ({ variant = "full", className = "", testId = "unlock-status" }) => {
  const { isUnlocked, unlockLabel } = useUnlock();
  const compact = variant === "compact";
  const hint = isUnlocked ? "AVAILABLE" : compact ? `UNLOCKS AT ${unlockLabel}` : `UNLOCKS AT ${unlockLabel} MARKET CAP`;

  return (
    <div
      className={`unlock-status ${isUnlocked ? "unlock-status--open" : "unlock-status--locked"} ${compact ? "unlock-status--compact" : ""} ${className}`}
      data-testid={testId}
      data-state={isUnlocked ? "unlocked" : "locked"}
      role="status"
    >
      <span className="unlock-status__icon">
        <AnimatePresence mode="wait" initial={false}>
          <motion.span
            key={isUnlocked ? "open" : "locked"}
            initial={{ rotate: -40, scale: 0.6, opacity: 0 }}
            animate={{ rotate: 0, scale: 1, opacity: 1 }}
            exit={{ rotate: 40, scale: 0.6, opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="grid"
          >
            {isUnlocked ? <LockOpen /> : <Lock />}
          </motion.span>
        </AnimatePresence>
      </span>
      <span className="min-w-0">
        <span className="unlock-status__label block" data-testid={`${testId}-label`}>
          {isUnlocked ? "UNLOCKED" : "LOCKED"}
        </span>
        {(!compact || !isUnlocked) && (
          <span className="unlock-status__hint block" data-testid={`${testId}-hint`}>{hint}</span>
        )}
      </span>
    </div>
  );
};
